// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { SpAlert } from '../../../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller($scope, $state, DropboxProvisioningService) {
    const $ctrl = this;
    this.$onInit = () => {
    const {
        applicationName,
        dropboxProvMappings,
        dropboxSyncMappings,
        groupMapping,
        saaspassGroups,
    } = this.resolve;
    $scope.groupMapping=groupMapping;
    $scope.saaspassGps=saaspassGroups;
    $scope.dropboxSyncMappings=dropboxSyncMappings;
    
    $scope.slectedGroups=[];
    $scope.allowedSpGroupTypes = ['CUSTOM','AD','EXTERNAL_EMAILS','DOMAIN'];

    $scope.querySpTypes = function(group) {
        var theIndex= dropboxProvMappings.findIndex(obj => obj.saaspassGroup.id == group.id);
        var groupType=angular.copy(group.type);
        return ((($scope.allowedSpGroupTypes.indexOf(groupType) != -1) 
                || (groupType=='APPLICATION' && group.groupName==applicationName))
                && (theIndex==-1));
    };

    $scope.saveMapping= function() {
        DropboxProvisioningService.provMapping.save({
            companyId: $state.params.companyId,
            appId: $state.params.appId
        },$scope.slectedGroups).$promise.then(function(data) {
            $ctrl.close({$value: data});
        }, function(error) {
            $scope.spAlert = new SpAlert('danger', error.data.message);
        });
    }
    $scope.slectDropDownValue=null;

    $scope.changeSelection = function(newValue, spGroupId) {
        if (newValue !== undefined) {
            var newPair = {
                saaspassGroupId : spGroupId,
                dropboxGroupId : newValue
            };
            var spPairIndex = $scope.slectedGroups.findIndex((obj => obj.saaspassGroupId == spGroupId));
            if (newValue != null) {
                if (newValue == 0) {
                    newValue = null;
                    newPair.dropboxGroupId = null;
                }
                if (spPairIndex != -1) {
                    $scope.slectedGroups[spPairIndex].dropboxGroupId = newValue;
                } else {
                    $scope.slectedGroups.push(newPair);
                }
            } else {
                if (spPairIndex != -1) {
                    $scope.slectedGroups.splice(spPairIndex, 1);
                }
            }
        }
    }
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning-mapping/dropbox-provisioning-mapping.controller.js